import Styles from './styles.module.css';
import { IoChatbubbleEllipsesOutline, IoDownloadOutline } from 'react-icons/io5';
import { DOC_DOWNLOAD_URL, CONSULT_URL } from '../_config';

const Cta = () => {
  return (
    <section className={Styles.cta}>
      <div className={Styles.motif} aria-hidden="true" />
      <div className={Styles.inner}>
        <h2>まずは、現在の求人票管理についてお聞かせください。</h2>
        <p>
          紙での保管、スキャン、Google Drive での管理など、
          <br className={Styles.brpc} />
          現在の運用方法に合わせて導入方法をご案内します。
        </p>
        <div className={Styles.actions}>
          {/* TODO: 学校専用の相談窓口が決まったら遷移先を差し替え（_config.ts） */}
          <a href={CONSULT_URL} className={Styles.primary}>
            <IoChatbubbleEllipsesOutline />求人票管理について相談する
          </a>
          <a href={DOC_DOWNLOAD_URL} className={Styles.secondary}>
            <IoDownloadOutline />資料をダウンロード
          </a>
        </div>
      </div>
    </section>
  );
};

export default Cta;
